import CompletedWorkoutService from "features/Workouts/services/CompletedWorkoutService";
import { CompletedWorkout } from "features/Workouts/Workouts.types";
import { useEffect, useState } from "react";
import { DateTime } from "types";
import { getTodayDateRangeParams } from "../../AthleteProfileActivityFeed.helpers";
import useCanDo from "hooks/useCanDo";

function useActivityFeedWorkouts(props: { id: string; date: DateTime }) {
  const { id, date } = props;
  const [completedWorkouts, setCompletedWorkouts] = useState<CompletedWorkout[]>([]);
  const workoutsEnabled = useCanDo("workout.any");

  useEffect(() => {
    if (!workoutsEnabled) return;

    (async () => {
      const dateParams = getTodayDateRangeParams(date);

      const result = await CompletedWorkoutService.getAll({ ...dateParams, athleteId: id });
      setCompletedWorkouts(result);
    })();

    return () => setCompletedWorkouts([]);
  }, [date, id, workoutsEnabled]);

  return completedWorkouts;
}

export default useActivityFeedWorkouts;
